import React from 'react';
import './dropdown.sass';
import Select from 'react-select';

export const DropdownSize = {
    DEFAULT: 'default',
    SMALL: 'small'
};

export const Dropdown = ({label, name, id, onChange, onBlur, defaultValue, options, isSearchable= true, size=DropdownSize.DEFAULT, placeholder}) => {

    return (
        <div className='vv-dropdown-container'>
            { label ? <p className='vv-dropdown-container__label'>{label}</p>: null}
            <Select
                className={`vv-dropdown vv-dropdown__${size}`}
                classNamePrefix='vv-dropdown'
                id={id}
                name={name}
                defaultValue={defaultValue}
                onBlur={onBlur}
                onChange={onChange}
                options={options}
                isSearchable={isSearchable}
                placeholder={placeholder}/>
        </div>
    );
};